const texts = {
  authorizationTabs: { signIn: "Iniciar sesión", signUp: "Regístrese" },
  general: {
    save: "Guardar",
    close: "Cerrar",
    next: "Siguiente",
    clearStep: "Borrar este paso",
    tryAgain: "Intentar de nuevo",
    errorTitle: "Error",
    service: "Servicio:",
    message: "Mensaje:",
    statusCode: "Código de estado:",
  },
  months: {
    "1": "Enero",
    "2": "Febrero",
    "3": "Marzo",
    "4": "Abril",
    "5": "Mayo",
    "6": "Junio",
    "7": "Julio",
    "8": "Agosto",
    "9": "Septiembre",
    "10": "Octubre",
    "11": "Noviembre",
    "12": "Diciembre",
  },
  signIn: {
    title: "Bienvenido a MultiMatch",
    description: "Cree su propia solución personalizada de Fertilizante de Liberación Controlada (CRF)",
    email: "E-Mail",
    password: "Contraseña",
    forgotPassword: "¿Olvidó su contraseña?",
    keepMeLoggedIn: "Mantenerme conectado desde este ordenador",
    keepMeLoggedInMobile: "Mantenerme conectado desde este dispositivo",
    emailApproved: "Su correo electrónico ha sido aprobado\nInicie sesión para continuar",
  },
  updatePassword: {
    title: "Establecer nueva contraseña",
    description: "Su contraseña debería tener",
    password: "Nueva contraseña",
    confirmPassword: "Confirmar contraseña",
    submitMessage: "Actualizar contraseña",
    success: " 'Su contraseña ha cambiado: redirigiendo a la página de inicio de sesión.'",
    UPDATE_PASSWORD_CONFIRMED: "Su contraseña ha sido confirmada con éxito",
    errors: {
      EMAIL_TOKEN_INVALID: "Su token de restablecimiento de contraseña no es válido",
      EMAIL_NOT_CONFIRMED: "Su dirección de correo electrónico no ha sido confirmada.",
      MAIL_NOT_CONFIRMED: "Su dirección de correo electrónico no ha sido confirmada.",
      PASSWORD_UPDATE_SUCCESS: "Su contraseña ha sido actualizada",
      PASSWORD_UPDATE_FAILED: "Su contraseña no se pudo actualizar",
      TEMP: "Token no válido o correo electrónico no confirmado",
    },
    sendEmail: "Hemos enviado un correo electrónico\nRevise su bandeja de entrada",
    errorPasswordRequired: "La contraseña y la confirmación de la contraseña no deben estar vacías",
  },
  signUp: {
    note: "Regístrese para guardar su información para uso futuro",
    passwordNote: " 'Su contraseña debe tener un mínimo de 8 caracteres: contener una mayúscula:  una minúscula y un número.'",
    fullName: "Nombre completo",
    country: "País",
    region: "Región",
    email: "E-mail",
    mainInterest: "Interés principal",
    expertise: "Área de conocimientos",
    password: "Contraseña",
    confirmPassword: "Confirmar contraseña",
    iAccept: "Acepto",
    termsAndConditions: "Términos y condiciones de Haifa",
    and: "y",
    privacyPolicy: "Política de privacidad",
    next: "Siguiente",
    emailSent: "Hemos enviado un correo electrónico a {0}\n" + " Compruebe su bandeja de entrada",
    didntGet: "¿No lo recibió?",
    checkBoxError: "Por favor apruébelo",
  },
  validationErrors: {
    fieldIsRequired: "Los campos obligatorios deben ser llenados",
    minimumValue: "Value must be larger than {0}",
    incorrectEmailFormat: "La dirección de correo electrónico no existe",
    passwordValidation: "Contraseña no válida",
    passwordsDontMatch: "Las contraseñas no coinciden",
    lettersOnly: "Por favor use solo letras",
    incorrectEmail: "Dirección de correo incorrecta",
    IncorrenctPassword: "Contraseña incorrecta",
    emailExisted: "La dirección de correo electrónico ya existe en el sistema",
    termsCheckbox: "Requerida",
    valueOutOfRange: "El valor debe estar entre {0} y {1}",
    invalidDateFormat: "Por favor introduzca una fecha válida",
    dateMustBeGreater: "La fecha de cosecha debe ser posterior a la de siembra",
    dateMustBeAtLeastTwoMonths: "La fecha debe ser de al menos dos meses",
    noServiceForSpecificCountry: "No se proporciona servicio para el país seleccionado",
    dateMaxDatesTwelveMonth: "El máximo es de un año.",
  },
  errorMessages: {
    generic: "Ocurrió un error: inténtelo de nuevo más tarde",
    LOGIN_FAILED: "El nombre de usuario o contraseña son incorrectos",
    MISSING_EMAIL: "Se requiere un correo electrónico.",
    EMAIL_INVALID: "Dirección de correo incorrecta",
    DUPLICATEUSERNAME: "Esta dirección de correo electrónico ya existe en el sistema",
    PASSWORD_INVALID: "Contraseña no válida",
    USERNAME_INVALID: "El nombre no puede contener caracteres especiales ni números",
    SPECIALIZATION_INVALID: "Especialización no válida",
    MAIN_INTEREST_INVALID: "Interés principal no válido",
    REGION_INVALID: "Región no válida",
    REGION_NOT_EXIST: "Región no existe",
    USER_NOT_FOUND: "Usuario no existe",
    USER_ALREADY_EXIST: "Usuario ya existe",
    MISSING_VALUES_TO_CONFIRM_REGISTRATION: "Registro fallido - le faltan valores",
    EMAIL_SENT_TO_USER: "Se ha enviado un correo al usuario",
    REGISTRATION_FAILED: "Error al registrar",
    TOKEN_INVALID: "Token de autenticación no válido",
    EMAIL_CONFIRMED_ALREADY: "La dirección de correo electrónico ya ha sido confirmada",
    NO_SOLUTION_MATCH: "No se ha encontrado ninguna solución ya prefabricada existente",
    EMAIL_CONFIRMED_SUCCESS: "El correo electrónico ha sido confirmado con éxito",
    VALIDATION_FAILED: "La validación ha fallado",
    ACCEPT_TERMS_INVALID: "Valor de aceptar términos no válido",
    SAVING_ITEM_FAILED: "Error al guardar el elemento",
    SAVED_ITEM_NOT_FOUND: "Elemento no existe",
    UPDATING_RECIPE_ITEM_FAILED: "Error al actualizar el elemento",
    REMOVING_RECIPE_ITEMS_FAILED: "Error al eliminar el elemento de la fórmula",
    REMOVING_GRAPH_ITEMS_FAILED: "Error al eliminar el elemento del gráfico",
    ITEM_UPDATED_SUCCESSFULLY: "El elemento ha sido actualizado con éxito",
    ITEM_DELETED_SUCCESSFULLY: "El elemento ha sido eliminado con éxito",
    RAW_MATERIAL_PARAMETERS_NOT_VALID: "Error al guardar nueva materia prima - Parámetros no válidos",
    SAVING_RAW_MATERIAL_FAILED: "Error al guardar nueva materia prima",
    RAW_MATERIAL_ALREADY_EXIST: "La materia prima ya existe",
    REMOVING_ITEM_FAILED: "Error al eliminar elemento",
    UPDATING_ITEMS_FAILED: "Error al actualizar elemento en la base de datos",
    CALCULATOR_IS_NOT_READY: "Cargando datos de la calculadora..",
    NUTRIENT_TYPE_INVALID: "Tipo de nutriente no válido",
    BLEND_INVALID: "Mezcla multicote no válida",
    TYPE_INVALID: "tipo no válido para una de las propiedades",
    MISSING_SAVED_ITEM_ID: "Falta el ID del elemento guardado en la solicitud",
    ITEM_NOT_FOUND: "Elemento no encontrado",
    RECIPE_TOTAL_ITEMS_COUNT_IS_MAXIMUM_6: "La receta no puede tener más de 6 materias primas",
    RECIPE_HAS_TO_HAVE_MINIMUM_1_COATED_AND_MAXIMUM_5_UNCOATED_MATERIALS:
      "La fórmula debe incluir al menos una materia prima recubierta y hasta 5 materiales sin recubrir",
    ONE_OR_MORE_INVALID_MATERIALS_IDS_IN_RECIPE: "Se han identificado una o más de materias primas no válidas en la fórmula",
    PERCENTAGE_SUM_MUST_BE_100_IN_RECIPE: "El porcentaje de mezcla debe ser 100%",
    START_DATE_REQUIRED: "Se requiere fecha de inicio",
    END_DATE_REQUIRED: "Se requiere fecha de finalización",
    END_DATE_MUST_BE_GRAETER_THEN_START_DATE: "La fecha de finalización debe ser posterior a la fecha de inicio",
    YIELD_VALUE_REQUIRED: "Se requiere rendimiento",
    COUNTRY_INVALID: "País no válido",
    CROP_CODE_INVALID: "Cultivo no válido",
    MESUREMENTS_INVALID: "Unidad de medida no válida",
    SOIL_AND_WATER_COMBINATION_INVALID: "Combinación de suelo y agua no válida",
    MONTHS_AND_TEMPATURES_INVALID: "Valores de meses y temperaturas no válidos",
    shareWithNoSaving: "lo siento: no se puede compartir un elemento no guardado",
    ITEM_NAME_TOO_SHORT: "nombre demasiado corto",
    ITEM_RENAME_FAILED: "ITEM_RENAME_FAILED",
    ITEM_DUPLICATE_FAILED: "ITEM_DUPLICATE_FAILED",
    UPDATE_PROFILE_FAILED: "UPDATE_PROFILE_FAILED",
  },
  rightDrawer: {
    showMoreText: "Mostrar",
    contactUs: "Contact us",
    findDealer: "Find a dealer",
  },
  fmSummary: {
    shortSummaryTitle1: "Cultivos",
    shortSummaryTitle2: "Suelo",
    shortSummaryTitle3: "Solución",
    shortSummaryTitle4: "Finca",
    shortSummaryTitleGraphPage: "Personalizar",
    ourProducts: "Nuestros productos",
    summary: "Datos recolectados",
    seeMoreProducts: "Ver más productos Multicote™",
    recipeCoatedElements: "Elementos recubiertos",
    recipeUncoatedElements: "Elementos sin recubrimiento",
  },
  fmLeftMenu: {
    title: "MultiMatch",
    subTitle: "Programas personalizados de nutrición vegetal",
    menuLabels: {
      label0: "Shlomit Adary",
      label1: "Solución con Multicote Agri",
      label2: "Solución con Multicote",
      label3: "Elementos guardados",
      label4: "Acerca de",
      label5: "Contáctenos",
    },
    logout: "Cerrar sesión",
  },
  steps: {
    cropsDesktop: "Cultivos",
    cropsMobile: "Características de su cultivo",
    soilDesktop: "Suelo",
    soilMobile: "Temperaturas y características del suelo",
    resultsDesktop: "Resultados",
    resultsMobile: "Resultados",
    farmDesktop: "Finca\n(Opcional)",
    farmMobile: "Práctica agrícola (opcional)",
    customizeDesktop: "Personalizar\n(Opcional)",
    customizeMobile: "Cree su propia mezcla (Opcional)",
  },
  agriSolution: {
    npkAlert: "NPK is Different from Crop Demand:",
    title: "Solución con Multicote Agri",
    selectCropLabel: "Seleccione su cultivo",
    expectedYieldLabel: "Rendimiento esperado",
    plotSizeLabel: "Tamaño de parcela en hectáreas",
    plantingDateLabel: "Fecha de siembra",
    finalHarvestExpectedDate: "Fecha esperada de cosecha final",
    selectPlotLocationLabel: "Seleccione la ubicación de la parcela",
    selectPlotLocationNote: "Sea lo más específico posible. Esto ayuda a evaluar los datos climáticos",
    selectArea: "o seleccione un área",
    selectOrAddNew: "Seleccionar de la lista o agregar nueva",
    onTheMap: "en el mapa",
    select: "Seleccionar",
    selectSoilLabel: "Temperaturas y características del suelo",
    waterRegime: {
      title: "Seleccione régimen hídrico",
      description: "¿Cuáles son las condiciones de precipitación en el área?",
      sliderMarks: {
        "1": "trocken",
        "2": "halbtrocken",
        "3": "halbtropisch",
        "4": "tropisch",
      },
    },
    soilType: {
      title: "Seleccionar tipo de suelo",
      description: "¿Cuál es el tipo de suelo de la parcela?",
      sliderMarks: {
        "1": "Sand,  loamy sand",
        "2": "Mittel sandig",
        "3": "Schlick, schluffiger Lehm, schluffiger Ton",
        "4": "Lehm und Ton bestehenden, Ton",
      },
    },
    soilWarning:
      " 'El requerimiento de nutrientes se basa en el rendimiento esperado. El programa de fertilizantes Multicote está diseñado para reemplazar todos los macronutrientes que extraerá el cultivo. El suelo se considera como un tampón y no se tiene en cuenta su contenido en nutrientes. Sin embargo: es una buena práctica agrícola tomar muestras de suelo cada 2 o 3 años y aplicar los correctores requeridos según el análisis del suelo. Esto asegurará que la fertilidad del suelo se mantenga y mejore con el tiempo.'",
  },
  fmDescriptionSnippet: {
    title: "Bienvenido a la calculadora de soluciones de Multicote",
    description:
      "Un software basado en la nube que permite tanto a productores particulares como a empresas: crear su propia solución personalizada de fertilizantes de liberación controlada (CRF) para  en unos pocos y sencillos pasos.'",
  },
  fmDropdownWithImg: { title: "Seleccione su cultivo" },
  back: "Atrás",
  fmRecommendedProduct: {
    volume: "Volumen de aplicación recomendado",
    method: "Método de aplicación",
    link: "Haga clic para obtener un gráfico de liberación",
  },
  pageStep1: {
    soilTemp: "Seleccionar temperatura del suelo",
    change: "Cambiar",
    note: "Seleccione su cultivo de la lista e introduzca el rendimiento esperado: la fecha de siembra y la fecha final de cosecha.",
    cfpTitle: "Carbon & Environmental footprint",
    cfpDesc: "assessment tool is now included in MultiMatch to help you improve your environmental impact",
    cfpButton: "Read More",
  },
  fertilizationPopup: {
    title: "Aplicación de nutrientes de fertilización",
    subTitle: "¿Conoce sus niveles actuales de nutrientes totales con su práctica actual de fertilización?",
    thirdTitle: "Seleccione `Los conozco` a continuación para calcular su nueva fórmula personalizada",
    iKnow: "Los conozco",
    iDontKnow: "No los conozco",
    next: "Siguiente",
  },
  saveProcessPopup: {
    title: "Guardar este proceso",
    subTitle: "Hemos detectado que tiene un proceso no guardado: ¿le gustaría continuar?",
    dontShowThisMessage: "No volver a mostrar esto",
    noThanks: " 'No: gracias'",
    save: "Guardar",
  },
  clearStepPopup: {
    title: "Borrar este paso",
    subTitle: "¿Está seguro de que desea borrar sus datos de este paso?",
    dontShowThisMessage: "No volver a mostrar esto",
    noGoBack: "Regresar",
    clear: "Borrar mis datos",
  },
  deleteItemPopup: {
    title: "Eliminar elemento",
    subTitle: "¿Seguro que desea eliminar este elemento?",
    no: "No",
    yes: "Sí",
  },
  saveItemPopup: {
    title: "Guardar solución",
    label1: "Nombre de la solución",
    label2: "Área",
    getBack: "Me gustaría que un especialista de Haifa revisara mi selección y me respondiese.",
    save: "Guardar",
    snackbar: "Elemento guardado",
  },
  pageStep4: {
    title: "Práctica agrícola",
    table: {
      nutrients: "Nutrientes",
      nutrientsUnit: "(Kg/Ha)",
      label1: "Práctica del agricultor",
      label2: "Requerimientos del cultivo",
      label3: "Ahorro de nutrientes del medio ambiente",
    },
    question: "¿Cuál es su práctica?",
    questionDescription:
      "si ya está utilizando ciertos fertilizantes que están produciendo rendimientos normales: indíquenos el NPK total aplicado por temporada. Utilizaremos estas tasas para calcular las tasas Multicote óptimas para su fórmula personalizada.",
    fill: "Rellene el campo `Su práctica",
    buttomDescription: "Gracias al uso de Multicote: la eficacia del uso de los nutrientes recubiertos aumenta considerablemente.",
    warningText1: "Aconsejamos ponerse en contacto con un",
    warningText2: "técnico profesional o distribuidor de Haifa",
    warningText3: "para confirmar su selección antes de la aplicación.",
    clearThisStep: "Borrar este paso",
    cfpBanner: "Data of used application rates helps the system calculate carbon and environmental footprint ",
    next: "Siguiente",
    save: "Guardar",
  },
  "Esto nos permite reducir el total de nutrientes aplicados":
    "reduciendo así la contaminación de las aguas subterráneas y la acumulación de concentraciones de sal no deseadas en el suelo",
  multicoteTable: { mesurmentUnit: " (%)" },
  mainInterests: { OFA: "Agricultura al aire libre", N: "Vivero" },
  metricMethods: { "1": "Métrica", "2": "Imperial" },
  specialties: {
    "1": "Jardinería \\ hobby",
    "2": "Agricultor",
    "3": "Contratista agrícola",
    "4": "Servicios de formación agrícola",
    "5": "Comercio",
    "6": "Otros",
  },
  PageReleaseChart: {
    greenMessage: {
      title1: "MODO DE EMPLEO",
      description1: "Aplique siempre las mezclas de productos Multicote en la zona de la raíz.",
      description2: "Para un rendimiento óptimo: debe cubrirse con tierra o mantillo.",
      subTitle: "Práctica recomendada",
      description3:
        "Aplicar en línea mientras siembra. 2ª mejor práctica. Distribuir de manera uniforme antes del cultivo las mezclas de Multicote en el lecho de siembra.",
      title2: "CUÁNDO",
      description4: " Durante la siembra o en la preparación de la parcela: pero no más de 2 semanas antes de la siembra.",
      title3: "CUÁNTO",
      description5:
        "La tecnología Multicote es segura para su aplicación: pero para una mejor práctica: asegúrese de que la maquinaria esté calibrada correctamente.",
      title4: "CURVA DE LIBERACIÓN",
      description6: "La curva de liberación muestra la liberación de nutrientes según la temperatura esperada del suelo",
      radioButtonLabel: "Elija un tema",
      shareUnsavedItem: "lo sentimos: no se puede compartir un elemento no guardado",
    },
    currentDayRemainingReleaseValues: {
      preValue: "Mes",
      postValue: "NPK restantes:",
      currentPrecentage: "Remaining NPK (Percentage):",
      Percentage: "(Percentage)",
    },
    sendToAgronomist: {
      preUserName: "El usuario",
      preCrop: "está planeando una solución para el cultivo",
      preYield: "con un rendimiento esperado de",
      preStartingDate: "Fecha de inicio:",
      preFinalDate: "Fecha final:",
      preSolutionName: "Solución:",
      materialCode: "Material code:",
      preVolumeApplication: "Volumen de aplicación",
    },
    warning: {
      description: "Será necesaria la aplicación adicional de elementos secundarios y micro. Para una recomendación completa",
      boldDescription: "contacte con su técnico o distribuidor local de Haifa",
    },
    buttons: {
      downloadFile: "Descargar PDF",
      sendToPro: "Enviar a un técnico agrónomo",
      shareLink: {
        desktop: "Compartir enlace",
        mobile: "Compartir",
      },
    },
  },
  wideTable: {
    kodkod: { title1: "Liberación de materiales", title2: "por Mes (Kg/Ha)" },
    sideLabel: { label1: "N (var)", label2: "P", label2_1: "O", label3: "K" },
    months: {
      month1: "Ene",
      month2: "Feb",
      month3: "Mar",
      month4: "Abr",
      month5: "Mayo",
      month6: "Jun",
      month7: "Jul",
      month8: "Ago",
      month9: "Sep",
      month10: "Oct",
      month11: "Nov",
      month12: "Dic",
    },
    caroselHeader: { title: "Liberación mensual (%)" },
    next: "Siguiente",
    back: "Atrás",
  },
  saveItemsPage: {
    title: "Soluciones guardadas",
    inputPlaceholder: "Intruduzca un tipo de cultivo o un área para encontrar sus mezclas guardadas",
    mobile_inputPlaceholder: "Introduzca un tipo de cultivo o un área",
    clearAll: "Borrar todo",
    loadMore: "Cargar más",
    savedItemCard: {
      rename: "Renombrar",
      delete: "Borrar",
      duplicate: "Duplicar",
      contact: "Contacto",
      showTo: "Mostrar elemento al técnico de Haifa",
    },
  },
  multicoteSolutionPage: {
    stepOne: {
      firstInput: "Seleccionar mezcla",
      secondInput: "Fecha de inicio",
      radioLabel1: "P2O5 K20",
      radioLabel2: "PK",
      selectTemperature: "Seleccionar temperatura",
      calculateButton: "Calcular",
      setTempratureButton: "Fijar Temperaturas",
    },
    title: "Solución Multicote",
    changeCalculationSetting: "Cambiar configuración del cálculo",
    save: "Guardar",
    line: "Línea",
    bar: "Barra",
    graphCodCodTitle: "Liberación de materiales",
  },
  pageStep3: {
    carbonFootprintLoadingText: "Por favor, no cierre esta ventana",
    carbonFootprintDesc: "Evaluación de la huella medioambiental y de carbono en todo el ciclo de cultivo",
    carbonFootprintButtonText: "¡Calcúlelo!",
    subTitle: "Su recomendación",
    customize: {
      bestSuit: "Fórmula más adecuada",
      subDescription: "Hemos encontrado esta fórmula que se adapta mejor a los requisitos de su cultivo",
      title: "¿Desea ajustar la fórmula?",
      secondSubDescription:
        "Usted puede ajustar esta fórmula o personalizarla para que se adapte a sus condiciones locales en unos pocos y sencillos pasos",
      button: "Ajustar fórmula",
      topLink: "Gráfico de liberación",
    },
    bottomTitle: "Fórmula lista para usar",
    bottomDescriptionWithMatch: "Esta es la fórmula ya preparada que más se aproxima a su recomendación",
    bottomDescriptionWithoutMatch:
      "No pudimos encontrar una fórmula adecuada para satisfacer los requisitos de su cultivo: el suelo y las condiciones climáticas",
    recommendedProduct: {
      description:
        "Nuestra recomendación se basa únicamente en el requerimiento del cultivo de NPK: de acuerdo con la demanda conocida de estos nutrientes. Las aplicaciones secundarias y de micronutrientes se realizarán de acuerdo con el análisis del suelo y los requisitos del cultivo.",
    },
    save: "Guardar",
    inSoil: "En el suelo",
    metric: "Kg/Ha",
    imperial: "ST/Acre",
  },
  pageStep5: {
    title: "Diseñe su propia mezcla",
    updateButton: "Actualizar cálculo de N: P: K",
    recipeValidationError: "La receta debe tener un mínimo de 1 material recubierto: y un máximo de 6 elementos en total",
    save: "Guardar",
    bestSolution: "Mejor solución",
    subTitle1: "Seleccione hasta 6 Materiales en total",
    coated: "Recubierto",
    uncoated: "Sin recubrimiento",
    completePercentage: "Porcentaje completado de su mezcla Multicote:",
    missing: "restante",
    clear: "Borrar este paso",
    continueButton: "Continuar con el gráfico de Liberación",
    bottomDrawer: {
      savedItem: "Elemento guardado",
      rename: "Renombrar",
      delete: "Borrar",
      reset: "Reiniciar",
      update: "Actualizar",
    },
    uncoatedHelperText: "",
    updateCard: {
      leftSpan: "N, P, K se calcula mediante su selección de materiales:",
      errorMessage: {
        missingWord: "Increase",
        extraWord: "Decrease",
        rightPart: "% for calculation",
      },
    },
  },
  userAreaPage: {
    title: "Mi perfil",
    tab1: "Perfil del usuario",
    tab2: "Mi banco de materias primas",
    inputLabel1: "Nombre completo",
    inputLabel2: "País",
    inputLabel3: "E-mail",
    inputLabel4: "su interés principal",
    inputLabel5: "Área de conocimientos (Opcional)",
    button: "Actualizar",
    inputSecondPage: "Sin recubrimiento",
    messages: { success: "Perfil actualizado con éxito" },
    uncoatedInputHelperText: "",
  },
  contactUs: {
    title: "¿Tiene dudas? ¿Necesita consultar?",
    secondTitle: "gracias por visitar nuestra plataforma",
    description:
      "Nos complace ayudarle con cualquier pregunta que pueda tener y nos encantaría conocer su experiencia para que podamos seguir mejorando nuestras ofertas",
    inputLabel1: "País",
    inputLabel2: "Región",
    inputLabel3: "Puesto",
    inputLabel4: "Método de cultivo",
    inputLabel5: "Número de móvil",
    inputLabel6: "Tamaño del área cultivada (ha)",
    inputLabel7: "Dirección de correo electrónico",
    inputLabel8: "Su mensaje",
    back: "Atrás",
    send: "Enviar",
    messages: {
      success: "Gracias por su correo electrónico. Nos pondremos en contacto con usted en breve.",
      invalidPhoneNumber: "Número de móvil no válido",
    },
  },
  PDFfile: {
    mateData: {
      createdBy: "Creado por:",
      name: "Nombre:",
      location: "Ubicación:",
      phoneNumber: "Teléfono:",
      Date: "Fecha:",
      Time: "Hora:",
    },
    summaryData: {
      nutrientsApplied: "Nutrientes aplicados:",
      collectedDataTitle: "Información recolectada:",
      cropsTitle: "Cultivos:",
      cropProp: "Cultivo",
      yieldProp: "Rendimiento",
      plotSize: "Plot Size",
      plantingDateProp: "Fecha de siembra",
      harvestDateProp: "Fecha de cosecha",
      soilTitle: "Suelo",
      WaterRegimeProp: "Régimen hídrico",
      soilProp: "Suelo",
      customizedTitle: "Personalizado",
      recipeCoatedTitle: "Elementos recubiertos",
      recipeUncoatedTitle: "Elementos sin recubrimiento",
      recommended: "Recomendado",
      MaterialCodeProp: "Código del material",
    },
    waver: {
      title: "DESCARGO DE RESPONSABILIDAD",
      body: {
        before: "Before using, the grower shall determine the suitability of the product for his intended use.",
        theGrower: "The grower assumes all risk and liability for consequential and incidental damages. This product",
        isSold: "is sold without warranty of any kind, expressed or implied, as to  its merchantability",
        orFitness: " or fitness for a particular purpose.",
        caution: "Caution: ",
        harmful: "Harmful is swallowed. Keep out of reach of children. Store under cool, dry conditions.",
      },
    },
    descriptionRecommended:
      "Nuestra recomendación se basa únicamente en los requisitos del cultivo para NPK: de acuerdo con la demanda\nconocida de estosnutrientes. Las aplicaciones secundarias y de micronutrientes se realizarán de acuerdo con el\nanálisis de suelo ylos requisitos del cultivo.",
    howToUse: {
      title: "MODO DE EMPLEO",
      body: {
        firstLine: "Aplique siempre las mezclas de productos Multicote en la zona de la raֳ­z.",
        secondLine: "For optimal performance, it must be covered with a few centimeters of soil",
        thirdLine: "or mulch.",
        fourthLinePartOne: "Best practice:",
        fourthLinePartTwo: "Apply in row while seeding.",
        fifthLinePartOne: "2nd best:",
        fifthLinePartTwo: "Spread evenly before cultivation and incorporate the Multicote™",
        fifthLinePartThree: "blends into the seedbed.",
        forOptimalPerformance: "For optimal performance, mix Multicote™ with potting soil before planting.",
        mixMulticote: " Mix Multicote™ with potting soil before planting.",
        secondBestPractice: "2nd best practice - Dibbling:",
        forLate: "for late application, make holes around the plant and apply ,Multicote™",
        evenly: "evenly, cover with soil.",
      },
    },
    when: {
      title: "CUÁNDO",
      body: {
        firstLine: "While seeding or at plot preparation, but not more than 2 weeks prior to ",
        secondLine: "planting. ",
      },
    },
    howMuch: {
      title: "CUÁNTO",
      body: {
        firstLine: "Multicote™ technology is safe for use, but for best practice make sure",
        secondLine: "machinery is correctly calibrated.",
      },
    },
    releaseCurve: {
      title: "CURVA DE LIBERACIÓN",
      body: "La curva de liberación muestra la liberación de nutrientes de acuerdo con las temperaturas del suelo esperadas",
    },
    nameOfFile: "Multicote™ - Nuestra Solución.pdf",
  },
  ShareEmail: {
    title: "Instrucciones",
    body: {
      please: "Por favor",
      find: "busque las",
      attached: "recomendaciones",
      recommendation: "adjuntas",
      Thank: "Muchas",
      you: "gracias",
      Haifa: "Haifa",
      Group: "Grupo",
    },
  },
  autoCompleteInput: {
    firstSpan: "Estos valores no son válidos",
    secondSpan: "El máximo de N: P: K es 46: 54: 62'",
    thirdSpan: "La suma máxima es 66",
    noOptions: "Sin opciones",
  },
  sideMenu: {
    termsAndCondition: {
      title: "Términos y Condiciones",
      contentTitle: "Términos de uso",
    },
    privacyPolicy: { title: "Política de privacidad" },
    copyRightTitle: "Copyright 2021 Haifa",
    poweredBy: "Desarrollado por",
  },
  cfpTable: {
    savingTitle: "Ahorro de CO2 eq.",
    reducedCo2: "Por",
    reducedCo2PerPlot: "Por parcela",
    rating: {
      excellent: "Excelente",
      worse: "Peor",
    },
    tableColumns: {
      envParams: "Parámetros medioambientales",
      multiTech: "Tecnología Multicote™",
      tradTech: "Aplicación tradicional",
      performanceRating: "Rendimiento de la tecnología Multicote™",
      index: "Índice",
    },
    tableRows: {
      carbonFootprint: {
        label: "Huella de carbono",
        measureUnit: "kg de CO2 eq./Kg producto",
      },
      nLeaching: {
        label: "Lixiviación de N",
        measureUnit: "kg de NO3/Kg de producto",
      },
      nRunOff: {
        label: "Vertidos de N",
        measureUnit: "kg de NO3/Kg de producto",
      },
      nVolatilization: {
        label: "Volatilización de N",
        measureUnit: "kg de NH3/Kg de producto",
      },
      terrestrialEutrophication: {
        label: "Eutrofización del suelo",
        measureUnit: "kg de P eq./Kg de producto",
      },
    },
    carbonBannerTitle: "Cálculo del ahorro de carbono",
    carbonBannerText: "((Huella de carbono de la aplicación tradicional)/ha - (Huella de carbono de la tecnología Multicote™)/ha) X Rendimiento esperado T/Ha)",
  },
};
export default texts;
